const ATHENA_CLI_BINARY = "athena-js";
const ATHENA_PACKAGE_NAME = "@xylex-group/athena";

export const ATHENA_MIGRATE_COMMAND = `${ATHENA_CLI_BINARY} migrate`;
export const ATHENA_NPX_MIGRATE_COMMAND = `npx ${ATHENA_PACKAGE_NAME} migrate`;
export const ATHENA_MIGRATE_STATUS_COMMAND = `${ATHENA_MIGRATE_COMMAND} status`;
export const ATHENA_MIGRATE_CHECK_STRICT_COMMAND = `${ATHENA_MIGRATE_COMMAND} check --strict`;
export const ATHENA_MIGRATE_RECONCILE_COMMAND = `${ATHENA_MIGRATE_COMMAND} reconcile`;
export const ATHENA_MIGRATE_RECONCILE_APPLY_YES_COMMAND = `${ATHENA_MIGRATE_RECONCILE_COMMAND} --apply --yes`;
export const ATHENA_MIGRATE_ALLOW_DIRTY_COMMAND = `${ATHENA_MIGRATE_COMMAND} --allow-dirty-migrations`;
export const ATHENA_MIGRATE_ALLOW_DIRTY_YES_COMMAND = `${ATHENA_MIGRATE_COMMAND} --allow-dirty-migrations --yes`;
export const ATHENA_MIGRATE_REPAIR_COMMAND = `${ATHENA_MIGRATE_COMMAND} repair`;
export const ATHENA_MIGRATE_REPAIR_YES_COMMAND = `${ATHENA_MIGRATE_REPAIR_COMMAND} --yes`;
export const ATHENA_MIGRATE_AUTH_SYNC_COMMAND = `${ATHENA_MIGRATE_COMMAND} auth sync`;
export const ATHENA_MIGRATE_AUTH_MATERIALIZE_COMMAND = `${ATHENA_MIGRATE_COMMAND} auth materialize`;
export const ATHENA_MIGRATE_AUTH_SYNC_DRY_RUN_COMMAND = `${ATHENA_MIGRATE_AUTH_SYNC_COMMAND} --dry-run`;
export const ATHENA_MIGRATE_EXPLAIN_COMMAND = `${ATHENA_MIGRATE_COMMAND} explain`;
